const TOPIC_TAGS = [
  { label: '剑尊归来87话', hot: '1.2万讨论' },
  { label: '我独自升级结局', hot: '9800讨论' },
  { label: '七月新番推荐', hot: '7600讨论' },
  { label: '韩漫天花板', hot: '6500讨论' },
  { label: '国漫崛起', hot: '5800讨论' },
  { label: '漫画APP推荐', hot: '5100讨论' },
  { label: 'BL漫画安利', hot: '4800讨论' },
  { label: '漫画创作技巧', hot: '4200讨论' },
  { label: '完结漫画整理', hot: '3900讨论' },
  { label: '下拉式阅读体验', hot: '3500讨论' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            读者们正在热议的漫画话题，加入讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-3xl mx-auto">
          {TOPIC_TAGS.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className="group inline-flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 rounded-full border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer no-underline"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{t.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{t.hot}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-6">
          <a
            href="#topics"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部话题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}